import React from "react";
import { arrayOf, bool, object, oneOf } from "prop-types";
import cx from "classnames";

const propTypes = {
  /** Labels for columns in the table. Value of the key in columns match with the key name in data */
  columns: arrayOf(object),
  /** Data to print out in the table. */
  data: arrayOf(object),
  /** Is set, if the table doesn't have header. */
  headDisabled: bool,
  /** Different colors for even and odd rows. */
  striped: bool,
  /** Determine if the table has/hasn't borders. */
  type: oneOf(["bordered", "clean"]),
};

const CLASS_ROOT = "table";

const Table = ({
  className,
  columns,
  data,
  headDisabled = false,
  type,
  striped,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${type}`]: type,
      [`${CLASS_ROOT}--striped`]: striped,
    },
    className
  );

  function noLabel(element) {
    return element.label === "";
  }

  const tableHead =
    headDisabled || columns.every(noLabel) ? null : (
      <thead>
        <tr>
          {columns.map((column, i) => (
            <th key={i.toString()}>{column.label}</th>
          ))}
        </tr>
      </thead>
    );

  const table = (
    <table className={classes} {...other}>
      {tableHead}
      <tbody>
        {data.map((row, i) => (
          <tr key={i.toString()}>
            {columns.map((column) => (
              <td key={column.key}>{row[column.key]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );

  return table;
};

Table.displayName = "Table";
Table.propTypes = propTypes;

export default Table;
